<template>
  <pt-post-manage class="pt-post-manage__page"></pt-post-manage>
</template>

<script>
import PtPostManage from 'cps/tool-operation/pt-post-manage/withData'
export default {
  name: 'pt-post-manage__view',
  components: {
    'pt-post-manage': PtPostManage
  }
}
</script>
